/* Dynamic Plot code copyright 2018 (c) Tuva Labs Inc. */
/**
 * Created by jpatel3 on 2018-01-30.
 */

// import {Dyn} from '../dynDataSet/dynMiscellany';
// import mediator from '../dynDataSet/mediatorUtil';

export const wrapDynSampleStats = function(Dyn) {

    var mediator = Dyn.mediator;

    /**
     * model for a single Sample Statistics table.
     * We make one table per visible attribute in the plot, in Sampling mode.
     * Used as array elements of Dyn.SampleStats.statTableData[]
     * Used to construct tables of SampleStatsComponent.jsx
     */
    class StatsTableModel {
        constructor( attribute ) {
            this.attributeId = attribute.id;
            this.attributeName = attribute.population ? attribute.population.longName : attribute.longName;
            this.display = false; // {boolean} if true, show the table
            //this.samples = null;    // {Array} one per sample generated (aka rows of table)
            this.columnMap = null;  // {*} id:{StatsColumn} mapping
            this.columnIds = null;  // {id,priority} column ids in priority order
        }
        isVisible() {
            return this.display;
        }
        resetColumns() {
            // reset the column data, erasing any old statistical data
            //this.samples = [];
            this.columnMap = {};
            this.columnIds = [];
        }
        getStdColumnIds() {
            // columns always present in a visible stats table, by ID
            return ['sampleNum', 'sampleName', 'caseCount'];
        }
        createStdColumns( samplesArray, precisionPref ) {
            // create standard columns (name will be updated by SampleStatsComponent.updateTable()
            this.getStdColumnIds().forEach((c, index, array) => {
                this.columnMap[c] = new StatsColumn( c, index );
            });
            // add cases/rows
            samplesArray.forEach( ( sample, index ) => {
                // this.samples.push(
                //     new SamplesModel(
                //         index+1, sample.name, sample.caseIndices.length, precisionPref ));
                this.columnMap.sampleNum.addCase( index+1, index+1 );
                this.columnMap.sampleName.addCase( null, sample.name );
                this.columnMap.caseCount.addCase( sample.caseIndices.length, sample.caseIndices.length );
                //console.log("sampleStats:addSamplesToStatsTable", index+1 );
            });
            this.sortColumns();
        }
        getOrAddColumn( measureElementType, measurePriority ) {
            let col = this.columnMap[measureElementType];
            if( !col ){ // add a new column to stats table for this attribute
                col = new StatsColumn(measureElementType, measurePriority)
                this.columnMap[col.id] = col;
                col.setNumSamples(this.columnMap.sampleNum.getNumSamples());
                this.sortColumns();
            }
            return col;
        }
        sortColumns() {
            // sort table columns in ascending priority order for consistency and to match order in Summary Table
            // See also Dyn.PlotMeasures.setMeasureNames() which sorts for SummaryTable
            let sortedIDs = [];
            for( let id in this.columnMap ) {
                if( this.columnMap.hasOwnProperty(id)) {
                    sortedIDs.push( { id:id,
                        priority: this.columnMap[id].priority });
                }
            }
            sortedIDs.sort( (a,b) => a.priority - b.priority );
            this.columnIds = sortedIDs.map( s => s.id ); // ids for this.columnMap[id]
        }
    }

    /**
     * Data in a StatsTableModel is stored in column-major order, to match the attribute-statistic
     * pairing that the column represents. e.g. a table may have "mean of weight", "std.dev. of weight"
     * as two columns, with 60 case values for the 60 rows of the table (one per sample).
     */
    class StatsColumn {
        constructor( id /*, name*/, sortPriority ) {
            Dyn.assert( Dyn.mathUtil.isFinite( sortPriority ));
            Dyn.assert( typeof id ==='string' && id );
            //this.name = name; // not needed, use Dyn.SampleStats.measureElements[].measureName instead
            this.id = id; // if a statistic, use Dyn.EPlotControl string, e.g. 'controlsPopulationMean'
            this.priority = sortPriority; // smaller numbers are first columns in table, see Dyn.EMeasurePriority
            this.precision = 0; // attribute-measure precision from Dyn.AveragesOfSamples.getPrecision()
            this.originalPrecision = 0; // precision of distribution values from Dyn.AveragesOfSamples.getOriginalPrecision()
            this.caseValues = []; // full precision numeric value for converting to distribution attribute
            this.caseStrings = []; // formatted display value for Sample Statistics tables
        }
        isAMeasure() {
            // return true if this column ID matches one of our measures (stats), else it is a standard column.
            return /controls*/.test(this.id); // matches 'controlsMean', etc? -- see Dyn.EPlotControl
        }
        getNumSamples() {
            return this.caseValues.length;
        }
        setNumSamples( newNumSamples ) {
            this.caseValues.length = newNumSamples;
            this.caseStrings.length = newNumSamples;
        }
        addCase( value, string ) {
            this.caseValues.push( value );
            this.caseStrings.push( string );
        }
        setCase( index, value, string ) {
            this.caseValues[index] = value;
            this.caseStrings[index] = string;
        }
        setPrecision( p, originalPrecision ) {
            this.precision = p;
            this.originalPrecision = originalPrecision;
        }
    }

    /**
     * model for a sample of an attribute of a StatsTableModel
     * Used as array elements of Dyn.SampleStats.statTableData[].samples[]
     */
    // class SamplesModel {
    //     constructor( rowNum, sampleName, caseCount, precisionPref ) {
    //         this.index = rowNum;
    //         this.name = sampleName;
    //         this.caseCount = caseCount;
    //         this.precisionPref = precisionPref;
    //         this.measuresObj = null;
    //         this.measuresArray = null;
    //     }
    // }

    class SampleStats {
    /**
     * Constructor for the data model of the Sample Statistics panel in plot.
     * Measures are statistical values like mean, median, Std. Deviation.
     * The measures come from the statistic controller objects in the plot,
     * e.g. Dyn.MeanElement, Dyn.MedianElement, etc.
     */
        constructor ( dataSet, plotShaper ) {

            // references to our Dyn.DataSet and Dyn.CaseSampler data
            this.dataSet = dataSet;         // reference to data set for plot elements {Dyn.DataSet}
            this.plotShaper = plotShaper;   // reference to the plot shaper that has stat controllers like Dyn.MeanElement {Dyn.PlotShaper}
            this.samplesArrayRef = [];      // reference to samples from DataSet.CaseSampler.sampleSets[{last}].samples : [ { id, name, caseIndices } ]

            // data for structuring the table of Sample Statistics (see SampleStatsComponent)
            this.sampleSerialNum = -1;      // serial number of the sample set we have stats for (to compare to caseSampler.samplerSerialNum)
            this.sampleSetValues = [];      // array of attribute values for each sample, used to calculate stats for each sample [ { "attribute-id":[1.3, 2.4, 5.6, 7,8] }], [], []
            this.sampledAttributeIDs = [];  // ids of attributes used in stats
            this.measureElements = {};      // map of elementType to measureName { elementType:{ measureName } }
            this.statTableData = [];        // array of StatsTableModel objects, one per Table, each table is for a single attribute on X or Y (plus hidden tables about to be deleted).
            this.needsPublish = true;       // true after stats are updated, before publishUpdates()
            /*  Example:
            this.statTableData =
            [   // array, one per attribute on X and Y axes
            {   // first table with measure of Body Weight for each of 2 samples generated
            attributeID: "Body_Weight_05",
            attributeName: "Body Weight",
            display: true,
            columnMap: { // map of StatsColumn values, with 2 case values each
            sampleNum: {StatsColumn},
            sampleName: {StatsColumn},
            caseCount: {StatsColumn},
            controlsMean: {StatsColumn},
            controlsPopulationMean: {StatsColumn}
            }
            columnIds: [sampleNum,SampleName,...] // determines correct column order of columnMap properties
            },
            {   // second table with measure of Body Length for each of 2 samples generated
            }
            ];
            */

            mediator.subscribe("records:randomSamplesPre-Update", ( args ) => {
                this.handleRandomSamplingUpdate( args );
            });
            mediator.subscribe( "plot:modelUpdated", ( args ) => {
                this.publishUpdates(); // only publishes plot calls to calcSampleStats() resulted in changes
            });
        }


        // list of known measure parameters used by callers to addToMeasuresArray(); these known measures get counted
        //knownMeasureParams: [ "setID", "measureName", "value", "attributeID" ],

        // list of set IDs, each set of measures with the same ID gets converted to a table by the Summary View.
        //knownSetIDs:        [ "std" ],
        //tableTitles: {
        //    /* setID    :   title */
        //    "blank":    "No Samples available.",
        //    "std":      "Measures" // mean median mode st-dev
        //},


        /**
         * Get or create the array of measures for the elementType ("controlsPercentage", etc.)
         * @param elementType {String} -- value in enum Dyn.EPlotControl indicating the Dyn.PlotElement control type
         */
        //getMeasuresArray : function( elementType ) {
        //    "use strict";
        //    Dyn.assert( typeof elementType === "string" && /controls*/.test( elementType ));
        //    if( ! (elementType in this.measures )) {
        //        this.measures[elementType] = [];
        //    }
        //    Dyn.assert( elementType in this.measures );
        //    return this.measures[elementType];
        //},

        /**
         * Notify the views, if our sample stats have changed since the last notification.
         */
        publishUpdates() {
            // caller is plotShaper.updatePositionsAndAdornments() which is called at end of plot update
            //   previously, MeanElement->CalcAdornments(), MedianElementCalcAdornments() have called
            //   sampleStats.calcSampleStats() which may update this.needsPublish flag if changes made
            //      then this.publishUpdates() notifies
            //          DataSet->CaseSampler, RandomSampleComponent, that plot elements have finished updating.
            // console.log("sampleStats:updated" /*, this */);
            if( this.needsPublish ) {
                mediator.publish( "sampleStats:updated", { sampleStats: this, caseSampler: this.dataSet.caseSampler });
                this.needsPublish = false;
            }
        }

        /**
         * Remove the stat table data for the given measure ("controlsMean", "controlsMedian", etc.)
         * @param elementType {String} -- value in enum Dyn.EPlotControl indicating the Dyn.PlotElement control type
         */
        removeMeasureFromSampleStats ( elementType ) {
            Dyn.assert( typeof elementType === "string" && /controls*/.test( elementType ));
            if( this.measureElements.hasOwnProperty( elementType )) {
                // remove measure from measureArray
                delete this.measureElements[elementType];
                // remove column of data associated with the measure
                this.statTableData.forEach( statsTable => {
                    // statsTable.samples && statsTable.samples.forEach( sample => {
                    //     if( sample.measuresObj && sample.measuresObj.hasOwnProperty( elementType )) {
                    //         // remove measure from this.statsTableData[*].samples[*].measuresObj
                    //         delete sample.measuresObj[elementType];
                    //         sample.measuresArray = this.getSortedMeasuresArray(sample.measuresObj); // rebuild from measuresObj
                    //     }
                    // });
                    delete statsTable.columnMap[elementType];
                    statsTable.sortColumns();
                });
                this.needsPublish = true;
            }
        }

        /** Get or create an array of attribute numeric values for the generated sample, removing non-numeric values */
        getOrCalcAttributeNumericValuesForSample( sampleIndex, datasetAttribute ) {
            Dyn.assertArrayIndex( this.sampleSetValues, sampleIndex );
            let sampleValues = this.sampleSetValues[ sampleIndex ],
                attributeID = datasetAttribute.id;
            Dyn.assert( 'attributes' in sampleValues );
            if ( !(attributeID in sampleValues.attributes)) {
                // fetch the attribute's numeric (non-missing) case values for this sample.
                let caseIndices = this.samplesArrayRef[ sampleIndex ].caseIndices;
                sampleValues.attributes[attributeID] = Dyn.AveragesOfSamples.getSampleNumericCaseValuesForAttribute( datasetAttribute, caseIndices );
            }
            return sampleValues.attributes[attributeID];
        }

        /**
         * Calculate a measure for the Sample Statistics table.
         *      Called when the given measure is calculated in the plot.
         *      Here will fill in the measure value for all of the samples, not just the current sample.
         * @param attributeID {Dyn.Attribute} -- attribute to add to Stats table
         * @param measureName {string} -- name of measure for Stats table
         * @param measureValue {number} -- current calculated value of measure (good for Population measures)
         * @param measureElementType {string} -- element type (Dyn.EPlotControl) for the measure to add to Stats Table
         */
        calcSampleStats ( attributeID, measureName, measureValue, measureElementType, distributionName ) {
            var datasetAttribute = Dyn.dataSet.getAttributeByID(attributeID),
                addedStats = false,
                updatedStats = false;

            Dyn.assert( datasetAttribute );
            if( ! this.dataSet.caseSampler.hasSamples()) {
                this.removeDataFromStatsTables();
                return;
            }

            // save the association between measure element type, measure name, and priority
            let measurePriority = Dyn.EMeasurePriority[measureElementType]; // for getSortedMeasuresArray()
            this.measureElements[measureElementType] = {
                measureName: measureName, // display name in table
                priority: measurePriority,
                distributionName: distributionName,
            };
            Dyn.assert( isFinite(measurePriority), "Priority '"+measureElementType+"' is not defined in Dyn.EMeasurePriority");

            // loop thru stats and if there are samples, add the measure value
            if( this.samplesArrayRef.length > 0 ) {
                this.statTableData.forEach( ( statsTable ) => {
                    if( statsTable.attributeId == attributeID ){
                        if( ! statsTable.columnMap[measureElementType ] ) {
                            addedStats = true;
                        }
                        let col = statsTable.getOrAddColumn( measureElementType, measurePriority ),
                            newPrecision = Dyn.AveragesOfSamples.getPrecision( datasetAttribute ),
                            precisionChanged = (col.precision !== newPrecision);
                        if( precisionChanged || addedStats ) {
                            col.setPrecision( newPrecision, Dyn.AveragesOfSamples.getOriginalPrecision( datasetAttribute ));
                            for( let i=0; i<col.getNumSamples(); ++i ) {
                                let attributeNumericValues = this.getOrCalcAttributeNumericValuesForSample( i, datasetAttribute );
                                let m = Dyn.AveragesOfSamples.calcAverage( measureElementType, datasetAttribute, attributeNumericValues, measureValue );
                                col.setCase( i, m.real, m.rounded );
                            }
                            statsTable.sortColumns( statsTable );
                            updatedStats = true;
                            this.needsPublish = true;
                        }
                    }
                });
            }
            //( addedStats || updatedStats )
            //    console.log("SampleStats:calcSampleStats() "+(addedStats?"added":"updated"), measureName /*, measureValue */ );
            // else
            //     console.log("SampleStats:calcSampleStats() ignored ", measureName, measureValue );
        }

        // update to our random sampling panel, either created, or updated,
        //  with or without a new sample being generated.
        handleRandomSamplingUpdate ( args ){
            let caseSampler = this.dataSet.caseSampler,
                newSampleSerialNum = caseSampler.getID(),
                lastSampleSet = caseSampler.getLastSampleSet(),
                haveNewSampleID = (this.sampleSerialNum !== newSampleSerialNum);
            Dyn.assert( args.sampleSets === caseSampler.sampleSets );

            // create our stats table data for each sample, erasing old sample data if old
            if( haveNewSampleID ){
                this.sampleSerialNum = newSampleSerialNum;
                // Dyn.assert( caseSampler.isSampleSelected() || ! caseSampler.hasSamples() );
                if( caseSampler.hasSamples() ) {
                    // set up or re-initialize the stats, because we have a new sample set
                    this.samplesArrayRef = lastSampleSet.samples;
                    this.sampleSetValues = [];
                    this.samplesArrayRef.forEach( (sample ) => {
                        this.sampleSetValues.push( { attributes:[] } ); // one per sample
                    });
                    if( this.samplesArrayRef.length > 0 ){
                        this.initDataInStatsTables(); // clear old measures and re-create std data
                    } else {
                        this.removeDataFromStatsTables(); // just clear old measures
                    }
                    this.updateStatsTablesByAttribute(); // add any missing stats tables for our attributes
                    // this.preCalcDistributionStats( args.statsChecked, args.statsUnchecked );
                    this.preCalcDistributionStats( args.statsChecked ); // calc just enough stats to generate distributions
                } else {
                    // no more samples, so remove associated stat tables.
                    this.removeStatsTables();
                }
                this.needsPublish = true;
                this.publishUpdates();
            }
            // else do nothing, because the sample set is unchanged
        }

        /** add a new stats table for the given attribute */
        addStatsTableData( attributeID ) {
            // console.log("addStatsTableData", attributeID );
            let attribute = Dyn.dataSet.getAttributeByID(attributeID);
            if( attribute ){
                let statsTable = new StatsTableModel(attribute);
                statsTable.resetColumns();
                if( this.samplesArrayRef.length > 0 ){
                    statsTable.createStdColumns(this.samplesArrayRef, Dyn.preferences.getPrecision());
                }
                this.statTableData.push(statsTable);
            }
        }

        /**
         * Remove old stats data, start again.
         * To be called when samples are generated or reset.
         */
        removeStatsTables() {
            this.sampleSetValues = [];
            this.statTableData = [];
        }


        /**
         * Initialize the columns of data in the stats table, # rows === number of samples.
         * See also removeSamplesFromStatsTables()
         */
        initDataInStatsTables () {
            this.statTableData.forEach( (statsTable) => {
                statsTable.resetColumns();
                statsTable.createStdColumns( this.samplesArrayRef, Dyn.preferences.getPrecision());
            });
        }

        /**
         * Remove the calculated sample and measure values for each stats table.
         */
        removeDataFromStatsTables() {
            // console.log("removeDataFromStatsTables");
            this.statTableData.forEach( (statsTable) => {
                statsTable.resetColumns();
            });
        }

        /**
         * Update the list of attributes that have sample statistics.
         * We use the X and Y axis attributes of the plot, and ignore other
         * plot attributes (legend, order by, etc).
         * @param attributeArrayOnX
         * @param attributeArrayOnY
         */
        setAttributeIDs ( attributeArrayOnX, attributeArrayOnY ) {

            let attributesOnXYAxes = attributeArrayOnX.concat(attributeArrayOnY),
                attributeIDsOnXYAxes = attributesOnXYAxes.map( attr => attr.id );

            // update the list of active attribute IDs
            this.sampledAttributeIDs = attributeIDsOnXYAxes;

            // update the stats tables, one per active attribute on the X or Y axis
            this.updateStatsTablesByAttribute();
        }

        /**
         * Create a stats table for each attribute on the X and Y axes.
         * and hide stats tables for attributes no longer on X or Y.
         */
        updateStatsTablesByAttribute () {
            let isSampling = this.dataSet.caseSampler.hasSamples(),
                attributeIDsInStatTables = this.statTableData.map( statsTable => statsTable.attributeId );

            // add X and Y attributes to table if needed
            this.sampledAttributeIDs.forEach( id => {
                if( ! attributeIDsInStatTables.includes( id )){
                    if( isSampling ) {
                        this.addStatsTableData( id );
                    }
                }
            });

            // if attribute is not on axis, mark it as visible false
            this.statTableData.forEach((statsTable) => {
                statsTable.display = this.sampledAttributeIDs.includes(statsTable.attributeId);
                // note: hidden stats tables are later deleted by this.removeStatsTables()
            });
        }

        /**
         * Calculate the minimum stats necessary to for getDistributionAttributeData().
         *
         * This is designed to be called before the dataSet and Plot and Table are notified
         * of the sampling change.
         *
         * Normally our plot calls calcSampleStats() as the plot and plot-attributes change,
         * But here we want to take the existing attributes and rebuild the sample stats just
         * enough to re-create the distribution, which is *before* the data set is modified,
         * which is before the plot is updated.
         * @param checkedStats {[]} - array of Dyn.EPlotControl strings
         */
            // preCalcDistributionStats : function( statsChecked, statsUnchecked ) {
        preCalcDistributionStats ( statsChecked ) {
            this.sampledAttributeIDs.forEach( attributeID => {

                // on regeneration of the sampling, remove the unchecked plotElements
                /*
                statsUnchecked.forEach( elementKey => {
                let controlString = Dyn.EPlotControl[elementKey],
                plotElement = this.plotShaper.findElement( controlString );
                if( plotElement ) { // add stat to plot if it does not yet exist
                this.plotShaper.removeElement( controlString );
                }
                });
                */
                statsChecked.forEach( elementKey => {
                    // for each sampled-attribute/statistic combination
                    let controlString = Dyn.EPlotControl[elementKey],
                        plotElement = this.plotShaper.findElement( controlString );
                    if( ! plotElement ) { // add stat to plot if it does not yet exist
                        plotElement = Dyn.PlotElemHelper.create( controlString );
                        if( plotElement ) {
                            this.plotShaper.addElement( plotElement );
                        }
                    }
                    Dyn.assert( plotElement, "unable to add stat to plot: "+controlString );
                    if( plotElement ){
                        let measureName = Dyn.AveragesOfSamples.getSampleMeasureName(plotElement),
                            distributionName = Dyn.AveragesOfSamples.getDistributionAttributeName(plotElement);
                        if( measureName && distributionName ){
                            this.calcSampleStats(attributeID, measureName, Dyn.dataUtil.kMissingValue, controlString, distributionName);
                        }
                        Dyn.assert( measureName && distributionName, "unable to find measure names:"+controlString );
                    }
                });
            });
        }

        getNumAttributesInDistribution () {
            // we count one distribution attribute for every measure (mean, std, etc) of each attribute
            // plus one for the "Cases" first attribute
            // so we sum this.statTableData[0..n].samples[0].measuresArray[0].length
            // NOTE: .samples and .measuresArray may not yet be defined
            let numAttributes = 0;
            this.statTableData.forEach( (statsTable, tableIndex) => {  // one table per attribute in the Sample Statistics tab
                if( tableIndex===0 && statsTable.columnMap.sampleNum ) {
                    ++numAttributes; // for the intrinsic "Cases" attribute created by getDistributionAttributeData()
                }
                if( this.getDistributionStatsColumn( statsTable )) {
                    ++numAttributes; // for the distribution attribute in this table, e.g. "Sample Means of Weight"
                }
            });
            return numAttributes;
        }

        getNumCasesInDistribution () {
            // we count one distribution case for each sample generated
            let statsTable0 = this.statTableData[0],
                statsColumn0 = statsTable0 && statsTable0.columnMap.sampleNum;
            return statsColumn0 ? statsColumn0.getNumSamples() : 0;
        }

        /**
         * Get the StatsColumn that has the distribution case data for a given attribute.
         * E.g. if attribute is Height, get cases for Sample Mean of Height, ignore Population Mean of Height.
         * @param statTable - stat table associated with a particular attribute
         * @returns {*} - a StatsColumn or null
         */
        getDistributionStatsColumn ( statsTable ) {
            /* Note: because there is one stat table per attribute,
            and the first measure in the stat table is usually what the user selected in the Sampler Panel.
            just use the first measure for the attribute as the distribution attribute.
            To improve on this, we should get the stat from the control panel settings and search for that
            particular statistic.
            */
            let colId = statsTable.columnIds.find( id => statsTable.columnMap[id].isAMeasure());
            return colId ? statsTable.columnMap[colId] : null;
        }

        /**
         * Get data to create an attribute in the Distribution of Samples table.
         * Caller must ensure that there is measure data, i.e. getNumDistributionAttributes() >= 0, first.
         * @param distAttribIndex
         * @returns {{cases: [], name: string, id: string, populationAttributeId: string}}
         */
        getDistributionAttributeData ( distAttribIndex ) {
            let caseSampler = this.dataSet.caseSampler,
                attributeData = null;

            if( distAttribIndex === 0 ) {
                // create a replacement for the "Cases" first attribute in the dataset, if it exists
                if( caseSampler.hasSamples() && (this.dataSet.getNumAttributes() >= 1)){
                    let attrib0 = this.dataSet.attribs[0];
                    Dyn.assert(Dyn.dataUtil.isSpecialAttribute_Case(attrib0) && attrib0.isCaseAttribute);
                    attributeData = {
                        id: attrib0.id, // to match to attribute ID
                        cases: Dyn.dataUtil.indexArray(this.getNumCasesInDistribution(), 1),
                        precision: 0
                    };
                    if( caseSampler.allowChangeToAttributeNames ){
                        attributeData.name = attrib0.name;
                        attributeData.longName = attrib0.longName;
                    }
                }
            } else {
                // create the nth attribute from a measure (sample statistic) of the given attribute
                let numPreviousAttrs = 1, // for "Cases" attribute
                    statsTable = this.statTableData.find( (t) => { // increment through attributes to find measures of each attribute
                        let distStatsColumn = this.getDistributionStatsColumn( t );
                        if( distStatsColumn ) {
                            if( distAttribIndex === numPreviousAttrs ) {
                                return true;
                            }
                            ++numPreviousAttrs;
                        }
                        return false; // skip this statTable, our measure is in a subsequent one
                    }),
                    distStatsColumn = statsTable && this.getDistributionStatsColumn( statsTable );
                if( distStatsColumn ){
                    attributeData = {
                        id: statsTable.attributeId, // to match to attribute ID
                        cases: Array.from( distStatsColumn.caseValues ),
                        precision: distStatsColumn.originalPrecision,
                    };
                    if( caseSampler.allowChangeToAttributeNames ) {
                        Dyn.assert( this.measureElements.hasOwnProperty( distStatsColumn.id ));
                        let measureElement = this.measureElements[distStatsColumn.id],
                            name = Dyn.loc("{{measureName}} of {{attributeName}}", {// e.g. "Sample Means of Body Weight (lbs)"
                                measureName: measureElement.distributionName || measureElement.measureName,
                                attributeName: statsTable.attributeName
                            });
                        attributeData.name = name;
                        attributeData.longName = name;
                    }
                    //console.log("SampleStats.getDistributionAttributeData() precision", attributeData.precision, attributeData.id );
                }
            }
            return attributeData;
        }

        // measureToDistributionAttributePrecision: function( statsColumn ) {
        //     // to get the precision to use for distribution attributes, we start with
        //     // the measure precision from Dyn.AveragesOfSamples.getPrecision() then
        //     // remove the user preference precision (used for measures, not for attributes)
        //     // Note that the average precision is complex, because both formulas and
        //     // user-attribute settings can override the data-value-derived precision
        //     return measurePrecision - Dyn.preferences.getPrecision();
        // },

        /** compare objects returned by getDistributionAttributeData() to see if they differ */
        isDistributionDataChanged ( oldAttrData, newAttrData ) {
            if( oldAttrData.name !== newAttrData.name
                || oldAttrData.id !== newAttrData.id
                || oldAttrData.precision !== newAttrData.precision
                || oldAttrData.cases.length !== newAttrData.cases.length ){
                return true; // found a change in name, etc.
            }
            let foundCaseValueChange = Boolean( oldAttrData.cases.find( (value, i) => value !== newAttrData.cases[i]));
            return foundCaseValueChange;
        }

    } // class SampleStats
    Dyn.SampleStats = SampleStats;

} // wrapDynSampleStats
